/* eslint-disable max-len */
export const article = {
  title: 'Hire Nick Day',
  parts: [
    {
      num: 1,
      headline: 'Review Resume',
      steps: [
        {
          num: 1,
          image: 'https://place-puppy.com/public-images/index-page/image4/410x280-lg.jpg',
          title: 'Locate Resume',
          line: 'Download resume here or find resume attached to application.',
          description: 'Nick Day has already applied to work at WikiHow, so his resume should be in the engineering-jobs inbox. However, if it is not easy to find or you simply do not want to look, download it here.',
          bullets: [
            {
              num: 1,
              content: 'Click here to download the resume'
            }
          ]
        }
      ]
    }
  ]
};
